import { useEffect, useState} from "react";
import { Box, TextField,/*Button,*/ Grid, makeStyles } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { moveNextPage , updateUserMetrics } from "../../../../../store/actions/creator/creatorExperienceBuilder";
import { apiClient } from "../../../../../config/apiClient";
import CreatorBtn from "../../../../atoms/creator/experienceBuilderEnterBtn";
import UtilService from '../../../../../helper/service';
import {useHistory, useLocation} from "react-router";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

const useStyles = makeStyles(() => ({
  subTitle: {
    fontSize: 23,
    fontFamily: 'roboto-bold',
    margin: '25px 0 0',
    color: '#697683'
  },
  subTitle1: {
    fontSize: 23,
    fontFamily: 'roboto-bold',
    color: '#697683'
  },
  description: {
    fontSize: 14,
    fontFamily: 'roboto-regular'
  },
  videoClipWrapper:{
    width: 210,
    borderRadius: 20,
    position:'relative',
    marginRight:20,    
  },
  videoClip: {
    width: 210,
    height: 135,
    borderRadius: 20,
    background:'#e5e5e5',
  },
  reelSessions:{
    '@media only screen and (min-width: 1820px)': {
      width: '70%'
    }
  },
  remove: {
    position: 'absolute',
    right: -10,
    top: -14,
    '&:hover': {
      cursor: 'pointer'
    }
  },
  description1: {
    font: 'normal normal normal 18px/30px Roboto',
    color:'#697683',
    letterSpacing: '-0.27px',
    maxWidth: '550px'
  },
  boldDescription:{
    fontSize: 24,
    fontFamily: 'roboto-bold',
    color:'#212D40',
    marginBottom:0,
    marginTop:'50px',
    letterSpacing:"-0.36px"
  },
  descriptionBold:{
    fontSize: 18,
    fontFamily: 'roboto-bold',
    color:'#697683',
    letterSpacing:"-0.27px"
  },
  goLiveBtn: {
    width: 144,
    height: 54,
    borderRadius: 6,
    background: '#017AEF',
    color: '#fff',
    textTransform: 'none',
    fontSize: 19,
    float: 'right',
    '&:hover': {
      background: '#0f9fef',
      color: '#fff',
    }
  },
  participantsIcon: {
    width: 24,
    height: 24
  },
  label: {
    "&$focusedLabel": {
      color: "#707070"
    },
    "&$erroredLabel": {
      color: "#707070"
    }
  },
  focusedLabel: {
    fontSize: 14,
    fontFamily: 'roboto-black',
  },
  erroredLabel: {},
  underline: {
    fontSize: 14,
    fontFamily: 'roboto-regular',
    color: '#8F99A3',
    "&$error:after": {
      borderBottomColor: "#017AEF"
    },
    "&:after": {
      borderBottom: `3px solid #017AEF`
    }
  },
  error: {},
  browseBtn: {
    flex: 1,
    textTransform: "unset",
    backgroundColor: '#F0F0F0',
    color: '#697683'
  },
  fileInput: {
    display: 'none'
  },
  creatorSubtitle:{
    marginTop:10
  }
}));

function PreReelName(props: any) {
  
  const classes = useStyles();
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const { userMetrics, page, 
  } = useSelector((state: any) => state.creatorExperienceBuilder);
  const { configation } = useSelector((state: any) => state.video);
  const {
    sessionCode,
    asyncExperienceName,
    advanceFeature,
    surveyLink,
    reelsLastActivePage,
    createReel,
    asyncLastActivePage
  } = userMetrics;
  const { clickCloseIcon, onRemove, selected } = props;

  const [reelName, setReelName] = useState('');
  const [selectedSessions, setSelectedSessions] = useState<any[]>([]);
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : "";

  useEffect(() => {
    UtilService.addHashTag(history, location.pathname, 'asyncgo');
  }, []);

  useEffect(() => {
    if (selected) {
      setSelectedSessions(selected);
      dispatch(updateUserMetrics('selectedSessions', selected));
    }
  }, [selected]);

  useEffect(() => {
    if (asyncExperienceName) {
      setReelName(asyncExperienceName);
    }
  }, [asyncExperienceName]);
  
  useEffect(() => {
    const getStimulus = async () => {
      const res = await apiClient(true).get(`/stimulus/v2/stimulus/${loginUserData.customer_id}/${sessionCode}`);
      dispatch(updateUserMetrics('stimulusList', res.data))
    };
    getStimulus();
  }, [dispatch, loginUserData.customer_id, sessionCode]);

  useEffect(() => {
    window.addEventListener('keydown', handleUserKeyPress);
    return () => {
      window.removeEventListener('keydown', handleUserKeyPress);
    };
  });

  const handleUserKeyPress = (event: any) => {
    if (event.keyCode === 13 && reelName.length > 0) {
      goNext();
    }
  };

  const goNext = () => {
    const nextPage = page + 1;
    dispatch(moveNextPage(nextPage));
    if (createReel) {
      (nextPage > asyncLastActivePage) && dispatch(updateUserMetrics('asyncLastActivePage', nextPage));
    } else {
      (nextPage > reelsLastActivePage) && dispatch(updateUserMetrics('reelsLastActivePage', nextPage));
    }
  };

  const changeReelName = (e: any) => {
    setReelName(e.target.value);
    dispatch(updateUserMetrics('asyncExperienceName', e.target.value));
  };

  const onChangeSurveyLink = (event: any) => {
    const surveyLink = event.target.value;
    dispatch(updateUserMetrics('surveyLink', surveyLink));
  };
  
  const toggleAdvancedFeature = () => {
    dispatch(updateUserMetrics('advanceFeature', !advanceFeature));
  };

  return (
    <>
      <Grid container>
        <Grid item xs={12} md={12}>
          <p className='creator-main-title mt-65'>
            {createReel ? 'Check your Reel!' : 'Time to set up your Reel!'}
          </p>
          <p className={classes.descriptionBold}>Your reel consists of the following experiences.</p>    
          <Box>
            <Grid container className={classes.description}>
            {selectedSessions && selectedSessions.length &&
              selectedSessions.map((sessiondata:any, key:number)=>(
                <Grid item key={key} >
                  <div className={classes.videoClipWrapper}>
                    <img src={sessiondata.img ? sessiondata.img : '/assets/images/placeholder.png'} className={classes.videoClip} key={key} alt={'img'}/>
                    <img onClick={() => onRemove(sessiondata)} src={'/assets/icons/dashboard/remove.svg'} className={classes.remove} alt="{close}" />
                    <p style={{width:'100%', textAlign:"center", marginTop:"0px"}}>{sessiondata.name}</p>
                  </div>
                  
                </Grid>
              ))
            }
            </Grid>
          </Box>
        </Grid>        
        <Grid item md={12} className="mt-20">
          <p className={classes.description1}>We’ll randomize the order of these when shown to your participants, and add time between each video to reset your participants’ emotional response.</p>
        </Grid>
        <Grid item md={12}>
          <p className={classes.boldDescription}>Great! Let’s name it - this is what your participants will see.</p>
        </Grid>
        <Grid item md={12} >
          <TextField
            InputLabelProps={{
              classes: {
                root: classes.label,
                focused: classes.focusedLabel,
                error: classes.erroredLabel
              },
            }}
            InputProps={{
              classes: {
                root: classes.underline,
                error: classes.error
              }
            }}
            onChange={(e:any)=> changeReelName(e)}
            style={{ flex: 7, width:"83%" }}
            margin="normal"
            id="reelName"
            value={reelName}
            label="Reel Name"
            name="reelName"
            autoFocus={true}
            helperText={
              configation && configation.data && configation.data.EnableSurvey == "FALSE" ?
                <></> : <span className="creator-helperText"><span className="survey-link" onClick={() => toggleAdvancedFeature()}>Advanced Features
              {advanceFeature ? <ExpandMoreIcon fontSize="small" /> : <ChevronRightIcon fontSize="small" />}
                </span></span>}
          />
          {advanceFeature &&
            <>
              <p className="creator-survey-link-description" style={{ flex: 7, width: "83%" }}
              >
                <strong>Add a survey </strong> for participants to fill out after watching your video by adding a link below.
                      </p>
              <TextField
                InputLabelProps={{
                  classes: {
                    root: classes.label,
                    focused: classes.focusedLabel,
                    error: classes.erroredLabel
                  },
                }}
                InputProps={{
                  classes: {
                    root: classes.underline,
                    error: classes.error
                  }
                }}
                style={{ flex: 7, width: "83%" }}
                margin="dense"
                defaultValue={surveyLink}
                id="surveyLink"
                label="Survey Link"
                name="surveyLink"
                onChange={onChangeSurveyLink}
              />
            </>
          }
        </Grid>
        <Grid item md={12}>
          <div className={classes.reelSessions}>
            <CreatorBtn isValidation={reelName.length > 0 ? surveyLink ? !UtilService.validateSurveyLink(surveyLink) : false : true } goNext={goNext} isRight={true} closeCreateReel={clickCloseIcon}/>
          </div>
        </Grid>
      </Grid>
      
    </>
  )
}

export default PreReelName;
